(ns bec-core.cljs.effects
  (:require [re-frame.core :as rf]
            [bec-cljs-common.re-frame.effects]
            [bec-core.cljs.routes :as routes]))

(rf/reg-fx :routes-push-state
  (fn [[view props]]
    (routes/push-state view props)))

(rf/reg-fx :routes-forward
  (fn [_] (routes/forward)))

(rf/reg-fx :routes-back
  (fn [_] (routes/back)))